<div class="delete-account-container">
  <div class="delete-card">
    <h1>Delete Account & Associated Data</h1>
    <p class="description">
      Deleting your account will permanently and irreversibly erase all your personal data, 
      configured calendars, saved notes, and associated recordings from our systems.
    </p>

    <div class="warning-banner">
      <strong>Warning:</strong> This action is final and cannot be undone.
    </div>

    <!-- Account Deletion Form -->
    <form [formGroup]="deleteForm" (ngSubmit)="onSubmit()" *ngIf="!isDeleted">
      <div class="form-group">
        <label for="email">Email Address</label>
        <input 
          id="email" 
          type="email" 
          formControlName="email" 
          placeholder="your.email@example.com"
          class="form-control"
          [class.invalid]="deleteForm.get('email')?.invalid && deleteForm.get('email')?.touched"
        />
        <div class="field-error" *ngIf="deleteForm.get('email')?.invalid && deleteForm.get('email')?.touched">
          Please enter a valid email address.
        </div>
      </div>

      <div class="form-group">
        <label for="password">Password</label>
        <input 
          id="password" 
          type="password" 
          formControlName="password" 
          placeholder="Your password"
          class="form-control"
          [class.invalid]="deleteForm.get('password')?.invalid && deleteForm.get('password')?.touched"
        />
        <div class="field-error" *ngIf="deleteForm.get('password')?.invalid && deleteForm.get('password')?.touched">
          Password is required.
        </div>
      </div>

      <div class="error-alert" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <button type="submit" [disabled]="deleteForm.invalid || isLoading" class="btn-delete">
        <span *ngIf="!isLoading">Permanently Delete Account</span>
        <span *ngIf="isLoading">Deleting account...</span>
      </button>
    </form>

    <!-- Success Confirmation -->
    <div class="success-message" *ngIf="isDeleted">
      <h3>Account Deleted</h3>
      <p>Your account and all associated data have been successfully deleted.</p>
    </div>
  </div>
</div>